<script setup lang="ts">

</script>

<template>
  <img
    class="object-cover"
    src="@/assets/images/feather.png"
  >
</template>

<style scoped>

</style>